export default __webpack_public_path__ + "static/media/icon_a_to_z.1cb49c65.svg";